export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true" fill="none">
    <circle cx="16" cy="16" r="11.5" stroke="var(--ink)" strokeWidth="2.6" />
    <circle cx="16" cy="11.4" r="2.5" fill="var(--coral)" />
    <circle cx="11.7" cy="19.4" r="2.5" fill="var(--saffron)" />
    <circle cx="20.3" cy="19.4" r="2.5" fill="var(--emerald)" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-lg font-bold tracking-tight text-ink">Amplified Minds</span>
  </span>
);
